import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";
import { useLanguage } from "context/LanguageContext";

function Information() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">{messages.testimonials.titleLead}</MKTypography>
          <MKTypography variant="h2" color="info" textGradient mb={2}>
            {messages.testimonials.titleHighlight}
          </MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            {messages.testimonials.description}
          </MKTypography>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name={messages.testimonials.reviews[0].name}
              date={messages.testimonials.reviews[0].date}
              review={messages.testimonials.reviews[0].review}
              rating={messages.testimonials.reviews[0].rating}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="info"
              name={messages.testimonials.reviews[1].name}
              date={messages.testimonials.reviews[1].date}
              review={messages.testimonials.reviews[1].review}
              rating={messages.testimonials.reviews[1].rating}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name={messages.testimonials.reviews[2].name}
              date={messages.testimonials.reviews[2].date}
              review={messages.testimonials.reviews[2].review}
              rating={messages.testimonials.reviews[2].rating}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
